type BreadcrumbItem = {
  label: string
  href: string
}

type BreadcrumbConfig = {
  [key: string]: (params: Record<string, string>) => BreadcrumbItem[]
}

export const breadcrumbConfig: BreadcrumbConfig = {
  "/dashboard": () => [{ label: "Simulations", href: "/dashboard" }],
  "/simulations/:testId/:runId/tutorial/intro": (params) => [
    { label: "Simulations", href: "/dashboard" },
    {
      label: params.simName,
      href: `/simulations/${params.testId}/${params.runId}/tutorial/intro`,
    },
    { label: "Tutorial", href: `` },
    { label: "Intro", href: `` },
  ],
  "/simulations/:testId/:runId/intro": (params) => [
    { label: "Simulations", href: "/dashboard" },
    { label: params.simName, href: `` },
    { label: "Intro", href: `` },
  ],
  "/simulations/complete": (params) => [
    { label: "Simulations", href: "/dashboard" },
    { label: params.simName, href: `` },
    { label: "Finished", href: `` },
  ],
  "/account": () => [{ label: "Account Management", href: "/account" }],
  "/dashboard/recruiter-admin/users/:group": () => [
    { label: "Admin", href: "/dashboard/recruiter-admin/users/all" },
    { label: "Users", href: "/dashboard/recruiter-admin/users/all" },
  ],
  "/dashboard/recruiter-admin/groups": () => [
    { label: "Admin", href: "/dashboard/recruiter-admin/groups" },
    { label: "Groups", href: "/dashboard/recruiter-admin/groups" },
  ],
}
